import * as tokens from '@hover/tokens-space';

var space = {
  0: tokens.size0,
  50: tokens.size50,
  100: tokens.size100,
  200: tokens.size200,
  300: tokens.size300,
  400: tokens.size400,
  500: tokens.size500,
  600: tokens.size600,
  700: tokens.size700,
  800: tokens.size800,
  900: tokens.size900,
  950: tokens.size950,
  1000: tokens.size1000,
  1100: tokens.size1100,
  1200: tokens.size1200
};

export { space as s };
